import styled from 'styled-components';
import { Tree } from 'antd';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 22rem;
  min-width: 22rem;
  padding: 1rem;
  background: ${COLORS.GRAY};
  border-radius: 1rem;
  align-self: flex-start;
`;

export const StyledSearchWrap = styled.div`
  .ant-input-affix-wrapper,
  .ant-input {
    background: ${COLORS.WHITE};
    border-radius: 0.75rem;
  }
`;

export const StyledTree = styled(Tree)`
  background: transparent;
  border: none;

  .ant-tree-treenode {
    width: 100%;
    padding: 0;
    align-items: center;
  }

  .ant-tree-switcher {
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    color: ${COLORS.DARK_GRAY};

    svg {
      width: 0.85rem;
      height: 0.85rem;
      transition: transform 0.15s ease;

      path {
        fill: currentColor;
      }
    }
  }

  /* ChevronIcon points down by default (collapsed); flip up when expanded */
  .ant-tree-switcher_open svg {
    transform: rotate(180deg);
  }

  .ant-tree-node-content-wrapper {
    width: 100%;
    min-height: auto;
    padding: 0.4rem 0.6rem;
    line-height: 1.25rem;
    border-radius: 0.6rem;
    ${pickThemeFontStyles('14', '20', 'NORMAL')};
    color: ${COLORS.BLACK};
    transition: background 0.15s ease;

    /* antd overlays a ::before box for hover/selected — hide it, we style the wrapper directly */
    &::before {
      display: none;
    }

    &:hover {
      background: ${COLORS.BRIGHT_GRAY};
    }
  }

  &&& .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background: ${COLORS.YELLOW_PRIMARY};
    font-weight: 600;
  }

  .ant-tree-title {
    color: ${COLORS.BLACK};
  }
` as typeof Tree;

export const StyledEmpty = styled.div`
  padding: 1.5rem 0.5rem;
  text-align: center;
  ${pickThemeFontStyles('14', '20', 'NORMAL')};
  color: ${COLORS.GREY};
`;
